import { Inject, Injectable } from '@angular/core';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { SessionService } from '../../session.service';
import type {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent } from '@angular/common/http';

import type { Observable } from 'rxjs';

@Injectable()
export class RestSessionInterceptor implements HttpInterceptor {

  private static readonly HTTP_STATUS_UNAUTHORIZED: number = 401;

  constructor(@Inject(SessionService) private sessionService: SessionService) {
  }

  intercept<T>(request: HttpRequest<T>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request)
      .pipe(
        tap({
          next: (event: HttpEvent<unknown>): void => {
            if (event instanceof HttpResponse && this.sessionService.hasSessionTimedOut(event.headers, event.body as { envelope: { authorizationToken: string } } | undefined)) {
              this.sessionService.redirectToLoginPage(event.headers);
            }
          },
          error: (error: unknown): void => {
            if (error instanceof HttpErrorResponse
                && (error.status === RestSessionInterceptor.HTTP_STATUS_UNAUTHORIZED
                    || this.sessionService.hasSessionTimedOut(error.headers))) {
              this.sessionService.redirectToLoginPage(error.headers);
            }
          }
        })
      );
  }

}
